import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="14" height="18" viewBox="0 0 14 18" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M2 3.03v11.94L11.3 9 2 3.03zM1.62.8l11.66 7.5a.83.83 0 010 1.4L1.62 17.2a.83.83 0 01-1.29-.7v-15A.83.83 0 011.62.8z" fill="#D8D8D8" fillRule="evenodd" /></svg>);